import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { HASURA_GRAPHQL_WS_URI, isBrowser } from '~/constants';
import { callRefreshToken } from '~/helpers/legacy-server-functions';
import { getToken, isTokenExpired } from '~/helpers/token';

const wsLink = isBrowser
    ? new GraphQLWsLink(
          createClient({
              url: HASURA_GRAPHQL_WS_URI,
              lazy: true,
              shouldRetry: () => true,
              retryAttempts: 2,
              keepAlive: 5_000,
              connectionParams: async () => {
                  let token = getToken();
                  if (!token) {
                      return { headers: {} };
                  }
                  if (isTokenExpired(token)) {
                      token = await callRefreshToken();
                  }
                  return {
                      headers: {
                          Authorization: token ? `Bearer ${token}` : '',
                      },
                  };
              },
          })
      )
    : undefined;

export default wsLink;
